import { useEffect, useState } from "react";
import { Button } from "primereact/button";

import { useAiHints } from "../../../contexts/SandboxHooks";

const HintStatus = {
  UNDEFINED: "undefined",
  READY: "ready",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

const getButtonText = status => {
  switch (status) {
    case HintStatus.LOADING:
      return "Generating hint...";
    case HintStatus.LOADED:
      return "View Aspen hint";
    case HintStatus.ERROR:
      return "Error... please try again";
    default:
      return "Need a hint?";
  }
};

const AiHintButton = ({ submission }) => {
  const [submissionHintStatus, setSubmissionHintStatus] = useState(HintStatus.UNDEFINED);
  const [isDisabled, setIsDisabled] = useState(true);
  const [buttonText, setButtonText] = useState("");

  const { generateAiHint, setHighlightedHint } = useAiHints();

  useEffect(() => {
    if (!submission.aiHint) {
      setSubmissionHintStatus(HintStatus.READY);
    } else {
      setSubmissionHintStatus(HintStatus.LOADED);
    }
  }, [submission]);

  useEffect(() => {
    setButtonText(getButtonText(submissionHintStatus));
    setIsDisabled(submissionHintStatus === HintStatus.LOADING);
  }, [submissionHintStatus]);

  // Handle the button click based on the current hint status
  const handleHintClick = () => {
    switch (submissionHintStatus) {
      case HintStatus.READY:
      case HintStatus.ERROR:
        generateNewHint();
        break;
      case HintStatus.LOADED:
        setHighlightedHint({
          submissionId: submission.runId,
          timestamp: new Date(),
        });
        break;
      default:
        // no op (loading)
        break;
    }
  };

  // Generate a new hint for the current submission, then show it
  const generateNewHint = async () => {
    setSubmissionHintStatus(HintStatus.LOADING);
    const result = await generateAiHint(submission.runId);
    if (result?.hint?.text) {
      setSubmissionHintStatus(HintStatus.LOADED);
      setHighlightedHint({
        submissionId: submission.runId,
        timestamp: new Date(),
      });
    } else {
      setSubmissionHintStatus(HintStatus.ERROR);
    }
  };

  return (
    <>
      <Button
        icon="pi pi-sparkles"
        text
        plain
        size="small"
        onClick={handleHintClick}
        disabled={isDisabled}
        label={buttonText}
      />
    </>
  );
};

export default AiHintButton;
